import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";

interface DepositFundsCreditCardPaymentProps {
  onSubmit(): void;
  onCancel(): void;
}
export default function DepositFundsCreditCardPayment({
  onSubmit,
  onCancel,
}: Readonly<DepositFundsCreditCardPaymentProps>) {
  return (
    <div className="w-full space-y-4">
      <div className="space-y-2">
        <Label htmlFor="card-number" className="text-xs text-muted-foreground">
          Card Number
        </Label>
        <Input
          id="card-number"
          type="text"
          inputMode="numeric"
          placeholder="1234 5678 9012 3456"
          autoComplete="cc-number"
        />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="expiration" className="text-xs text-muted-foreground">
            Expiration
          </Label>
          <Input
            id="expiration"
            type="text"
            placeholder="MM/YY"
            autoComplete="cc-exp"
            inputMode="numeric"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="cvc" className="text-xs text-muted-foreground">
            CVC
          </Label>
          <Input
            id="cvc"
            type="password"
            placeholder="***"
            autoComplete="cc-csc"
            inputMode="numeric"
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label
          htmlFor="account-holder"
          className="text-xs text-muted-foreground">
          Account Holder Name
        </Label>
        <Input
          id="account-holder"
          type="text"
          placeholder="Account Holder Name"
          autoComplete="cc-name"
        />
      </div>
      <div className="flex flex-col gap-3 pt-4">
        <Button onClick={onSubmit} className="w-full">
          Deposit $100 Now
        </Button>
        <Button variant="outline" onClick={onCancel} className="w-full">
          Cancel
        </Button>
      </div>
    </div>
  );
}
